import './App.css';
import Navigator from './components/Navigation/Navigation';
function App() {
  return (
    <Navigator />
  );
}

export default App;
